<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			企业二维码展示申请
		</div>

		<div style="width: 100%;height: 50px;margin-top: 25px;">
			<div @click="ctm('2')"
				style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;float: left;margin-left: 5px;">
				交流群二维码添加
			</div>
			<div @click="ctm('3')"
				style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;float: left;margin-left: 5px;">
				企业模型二维码添加
			</div>
			<div @click="ctm('7')"
				style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;float: left;margin-left: 5px;">
				交流群模块
			</div>
			<div @click="ctm('6')"
				style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;float: left;margin-left: 5px;">
				企业模型
			</div>
		</div>

		<!-- <div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div
				style="width: 820px;height: 30px;font-weight: 800;text-align: center;line-height: 30px;font-size: 18px;margin-left: 20px;">
				<el-radio-group v-model="cid" @change="gotosb()">
					<el-radio-button label="2">交流群二维码添加</el-radio-button>
					<el-radio-button label="3">企业模型二维码添加</el-radio-button>
					<el-radio-button label="7">交流群模块</el-radio-button>
					<el-radio-button label="6">企业模型</el-radio-button>
				</el-radio-group>
			</div>
		</div> -->

		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="this.cid=='2'" style="min-height: 300px;">
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						单位:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						联系人:
					</div>
					<el-input v-model="form.lxr" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						职位:
					</div>
					<el-input v-model="form.zw" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						手机:
					</div>
					<el-input v-model="form.mbphone" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>


				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						邮箱:
					</div>
					<el-input v-model="form.email" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						电话:
					</div>
					<el-input v-model="form.phone" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						二维码:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>


				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						链接地址:
					</div>
					<el-input v-model="form.link" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
				</div>

			</div>
			<div v-show="this.cid=='3'" style="min-height: 300px;">
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						单位:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						联系人:
					</div>
					<el-input v-model="form.lxr" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						职位:
					</div>
					<el-input v-model="form.zw" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						手机:
					</div>
					<el-input v-model="form.mbphone" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>


				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						邮箱:
					</div>
					<el-input v-model="form.email" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						电话:
					</div>
					<el-input v-model="form.phone" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						二维码:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>


				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						链接地址:
					</div>
					<el-input v-model="form.link" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
				</div>
			</div>
			<div v-show="this.cid=='6'" style="min-height: 300px;text-align: center;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;"
					v-for="(item,index) in ewmzssqa">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
						<div v-show="item.status=='0'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<!-- <div
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
							查看
						</div> -->
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
			</div>
			<div v-show="this.cid=='7'" style="min-height: 300px;text-align: center;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;"
					v-for="(item,index) in ewmzssqa">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
						<!-- <div v-show="item.status=='0'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div> -->
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<!-- <div
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
							查看
						</div> -->
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<!-- <div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				cid: '7',
				xsa: false,
				qid: '',
				fileListss: [],
				currentPage: 1, //当前页
				PageSize: 10, //当前每页数据
				Totals: 100, //总数据条数
				form: {
					title: '',
					lxr: '',
					zw: '',
					mbphone: '',
					email: '',
					phone: '',
					ewm: '',
					link: '',
				},
				ewmzssqa: '',
			}
		},
		mounted() {
			this.gotosb()
		},
		methods: {
			ctm(val) {
				this.cid = val
				this.gotosb()
			},
			handlePreview(file) {
				console.log(file);
			},
			
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handsuccessss(response, file, fileList) {
				this.form.ewm = response.data.path
			},
			async detela(id, mid) {
				console.log(id, mid)
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/delete', {
					model: 'ewm',
					type: 'content',
					mid: mid,
					uid: loginInfo.id,
					field_name: 'id',
					field_id: id
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '删除成功',
						type: 'success'
					});
				}
				this.gotosb()
			},
			xiugaia(val) {
				this.xsa = true
				if (this.cid == '6') {
					this.cid = '3'
				} else if (this.cid == '7') {
					this.cid = '2'
				}
				this.qid = val.id
				this.form.title = val.title
				this.form.lxr = val.lxr
				this.form.zw = val.zw
				this.form.mbphone = val.mbphone
				this.form.email = val.email
				this.form.phone = val.phone
				this.form.ewm = val.ewm
				this.form.link = val.link
				let fileArrss = [];
				let fileObjss = {};
				fileObjss.name = "图片";
				fileObjss.url = val.ewm;
				fileArrss.push(fileObjss);
				this.fileListss = fileArrss
			},
			async onSubmit() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.xsa == true) {
					if (this.cid == '3') {
						let res = await http.post('api/Common/edit', {
							model: 'ewm',
							type: 'content',
							mid: '3',
							fid: '6',
							title: this.form.title,
							lxr: this.form.lxr,
							zw: this.form.zw,
							mbphone: this.form.mbphone,
							email: this.form.email,
							phone: this.form.phone,
							ewm: this.form.ewm,
							content: this.form.content,
							link: this.form.link,
							uid: loginInfo.id,
							id: this.qid
						})
						if (res.data.code == 200) {
							this.$notify({
								title: '成功',
								message: '修改成功',
								type: 'success'
							});
							this.fileListss = []
							this.form.title = ''
							this.form.lxr = ''
							this.form.mbphone = ''
							this.form.email = ''
							this.form.phone = ''
							this.form.ewm = ''
							this.form.link = ''
						}
					} else if (this.cid == '2') {
						let res = await http.post('api/Common/edit', {
							model: 'ewm',
							type: 'content',
							mid: '2',
							fid: '7',
							title: this.form.title,
							lxr: this.form.lxr,
							zw: this.form.zw,
							mbphone: this.form.mbphone,
							email: this.form.email,
							phone: this.form.phone,
							ewm: this.form.ewm,
							content: this.form.content,
							link: this.form.link,
							uid: loginInfo.id,
							id: this.qid
						})
						if (res.data.code == 200) {
							this.$notify({
								title: '成功',
								message: '修改成功',
								type: 'success'
							});
							this.fileListss = []
							this.form.title = ''
							this.form.lxr = ''
							this.form.mbphone = ''
							this.form.email = ''
							this.form.phone = ''
							this.form.ewm = ''
							this.form.link = ''
						}
					}
				} else if (this.xsa == false) {
					if (this.cid == '2') {
						let res1 = await http.post('api/Common/add', {
							model: 'ewm',
							type: 'content',
							mid: '2',
							fid: '7',
							title: this.form.title,
							lxr: this.form.lxr,
							zw: this.form.zw,
							mbphone: this.form.mbphone,
							email: this.form.email,
							phone: this.form.phone,
							ewm: this.form.ewm,
							content: this.form.content,
							link: this.form.link,
							uid: loginInfo.id
						})
						if (res1.data.code == 200) {
							this.$notify({
								title: '成功',
								message: '上传成功',
								type: 'success'
							});
							this.fileListss = []
							this.form.title = ''
							this.form.lxr = ''
							this.form.mbphone = ''
							this.form.email = ''
							this.form.phone = ''
							this.form.ewm = ''
							this.form.link = ''
						}

					} else if (this.cid == '3') {
						let res2 = await http.post('api/Common/add', {
							model: 'ewm',
							type: 'content',
							mid: '3',
							fid: '6',
							title: this.form.title,
							lxr: this.form.lxr,
							zw: this.form.zw,
							mbphone: this.form.mbphone,
							email: this.form.email,
							phone: this.form.phone,
							ewm: this.form.ewm,
							content: this.form.content,
							link: this.form.link,
							uid: loginInfo.id
						})
						if (res2.data.code == 200) {
							this.$notify({
								title: '成功',
								message: '上传成功',
								type: 'success'
							});
							this.fileListss = []
							this.form.title = ''
							this.form.lxr = ''
							this.form.mbphone = ''
							this.form.email = ''
							this.form.phone = ''
							this.form.ewm = ''
							this.form.link = ''
						}

					}
				}
			},
			async handleCurrentChange(val) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
					let res = await http.get('api/picture/personl_page_mpsx', {
						uid: loginInfo.id,
						page: val
					})
					console.log(res)
					this.ewmzssqa = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				
				
				
			},
			async gotosb() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.cid == '6') {
					let res = await http.post('api/Common/index', {
						model: 'ewm',
						type: 'content',
						mid: '3',
						uid: loginInfo.id
					})
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
					this.ewmzssqa = res.data.data.list.data
				} else if (this.cid == '7') {
					let res = await http.post('api/Common/index', {
						model: 'ewm',
						type: 'content',
						mid: '2',
						uid: loginInfo.id
					})
					this.ewmzssqa = res.data.data.list.data
				}
			}
		}
	}
</script>

<style>
</style>
